import React from 'react'
import { BreadCrumbsContainer, BreadCrumbItem, Separator } from './BreadCrumbsStyle'

interface BreadCrumbItemProps {
  label: string
  onClick?: () => void
}

interface BreadCrumbsProps {
  items: BreadCrumbItemProps[]
}

const BreadCrumbs: React.FC<BreadCrumbsProps> = ({ items }) => {
  if (!items || items.length === 0) return null

  return (
    <BreadCrumbsContainer>
      {items.map((item, index) => (
        <React.Fragment key={`breadcrumb-${index}`}>
          <BreadCrumbItem onClick={item.onClick} isActive={index === items.length - 1}>
            {item.label}
          </BreadCrumbItem>
          {index < items.length - 1 && (
            <Separator>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_4529_15750)">
                  <path d="M6 4L10 8L6 12" stroke="#667085" strokeLinecap="round" strokeLinejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_4529_15750">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </Separator>
          )}
        </React.Fragment>
      ))}
    </BreadCrumbsContainer>
  )
}

export default BreadCrumbs
